/**
 * ExclamationCircle Icon Component
 * 
 * SVG icon for critical severity alerts
 */

import React from 'react';

const ExclamationCircleIcon = ({ size = 16, color = 'currentColor', className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={`exclamation-circle-icon ${className}`}
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  );
};

export default ExclamationCircleIcon;
